export default "__VITE_ASSET__DqntgiET__"